import { Box, Grid, Link, Typography, useTheme } from '@mui/material';
import { News } from '../../../../types/news';
import { createExcerptFromArray, getExcerpt, stripHTML } from '../../../../utils/text';
import { generatePath, Link as RouterLink } from 'react-router-dom';
import { APP_URLS } from '../../../../routes/urls';
import { AppIcon } from '../../../../components/app-icon/AppIcon';
import { ArrowRightIcon } from '../../../../assets/icons';
import { NewsCard } from '../../../../components/news-card/NewsCard';
import { homeNewsStyles } from './styles';
import { getDefaultImageSrc, loadDefaultImageOnError } from '../../../../utils/image';
import { NoDataIllustration } from '../../../../assets/illustration';
import { Swiper, SwiperSlide } from 'swiper/react';
import { SwiperOptions } from 'swiper';

interface NewsTabPanel {
  news: News[];
}
export const NewsTabPanel: React.FC<NewsTabPanel> = ({ news }) => {
  const theme = useTheme();
  if (news.length === 0)
    return (
      <Box sx={homeNewsStyles.emptyDataContainer}>
        <AppIcon
          sx={homeNewsStyles.emptyDataIllustration}
          Icon={NoDataIllustration}
          titleAccess="No news found for this day"
        />
        <Typography variant="large" fontWeight="Medium" sx={{ mt: 2.5 }} color="secondary">
          No news found for this day :(
        </Typography>
      </Box>
    );

  const [firstNews, ...otherNews] = news;
  const firstNewsCategoryExcerpt = createExcerptFromArray(
    firstNews.categories.map((category) => category.title),
    100
  );
  const firstNewsContentExcerpt = getExcerpt(stripHTML(firstNews.content), 400);

  const sliderBreakpoints: SwiperOptions['breakpoints'] = {
    [theme.breakpoints.values.sm * 16]: { slidesPerView: 2 },
    [theme.breakpoints.values.lg * 16]: { slidesPerView: 3 },
    [theme.breakpoints.values.xl * 16]: { slidesPerView: 4 },
  };
  return (
    <Grid container spacing={2.5}>
      <Grid item xs={12}>
        <Box sx={{ mb: 2.5 }}>
          <Grid container alignItems="center" spacing={2.5}>
            <Grid xs={12} md={7} lg={8} item>
              <Box
                sx={homeNewsStyles.newsImage}
                component="img"
                src={firstNews.media || getDefaultImageSrc('news')}
                onError={loadDefaultImageOnError.bind(null, 'news')}
              />
            </Grid>
            <Grid item xs={12} md={5} lg={4}>
              <Typography variant="medium" color="secondary" fontWeight="Medium">
                {firstNewsCategoryExcerpt}
              </Typography>
              <Typography sx={{ mt: 1.5, mb: 3 }} variant="h5" component="h3">
                {firstNews.title}
              </Typography>
              <Typography paragraph variant="medium" color="secondary">
                {firstNewsContentExcerpt}
              </Typography>
              <Link
                sx={{ textTransform: 'uppercase' }}
                underline="hover"
                component={RouterLink}
                to={generatePath(APP_URLS.singleNews, { newsSlug: firstNews.slug })}
              >
                Read more
                <AppIcon Icon={ArrowRightIcon} sx={{ fontSize: '1rem', height: 'auto', ml: 1 }} />
              </Link>
            </Grid>
          </Grid>
        </Box>
      </Grid>
      {otherNews && otherNews.length > 0 && (
        <Grid item xs={12}>
          <Swiper slidesPerView={1} breakpoints={sliderBreakpoints}>
            {otherNews.map((news) => (
              <SwiperSlide key={news.id}>
                <Box sx={{ pr: 2.5, height: 1 }}>
                  <NewsCard news={news} />
                </Box>
              </SwiperSlide>
            ))}
          </Swiper>
        </Grid>
      )}
    </Grid>
  );
};
